import { RRule, Weekday } from 'rrule';

export enum VisibilityOptions {
  owner = 'owner',
  public = 'public',
  custom = 'custom',
}
export const visibilityOptions: VisibilityOptions[] = Object.values(VisibilityOptions);

export const statusOptions = ['active', 'draft', 'closed'];

export const monthDaysNums = [...Array(28).keys()].map(day => day + 1);

export const remindPeriods: { [key: string]: string } = {
  [RRule.DAILY.toString()]: 'day',
  [RRule.WEEKLY.toString()]: 'week',
  [RRule.MONTHLY.toString()]: 'month',
};

export const ruleWeekdayMap: { [key: string]: Weekday } = {
  monday: RRule.MO,
  tuesday: RRule.TU,
  wednesday: RRule.WE,
  thursday: RRule.TH,
  friday: RRule.FR,
  saturday: RRule.SA,
  sunday: RRule.SU,
};

export const weekdayArr = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export const weekdays = [
  { key: 'monday', valKey: 'x.weekday.bubbles.monday' },
  { key: 'tuesday', valKey: 'x.weekday.bubbles.tuesday' },
  { key: 'wednesday', valKey: 'x.weekday.bubbles.wednesday' },
  { key: 'thursday', valKey: 'x.weekday.bubbles.thursday' },
  { key: 'friday', valKey: 'x.weekday.bubbles.friday' },
  { key: 'saturday', valKey: 'x.weekday.bubbles.saturday' },
  { key: 'sunday', valKey: 'x.weekday.bubbles.sunday' },
];

export const hourTimeFactory = (num: number) => `${num < 10 ? `0${num}` : num}:00`;

export const times = [...Array(24).keys()].map(hourTimeFactory);
